import React from 'react';

export const ContentMessage = ({ message, show }) => show ? (
    <div className="content-message">
        { message }
    </div>
) : null;
